import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DealerPartsService } from '../../business-services/dealer-parts.service';

@Injectable({ providedIn: 'root' })
export class EditDealerPartsServiceGuard  {

  constructor(
    private dealerPartService: DealerPartsService,
    private router: Router
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.dealerPartService.dealerPartId) {
      return true;
    }
    return this.router.createUrlTree(['/dealerparts']);
  }
}
